// import hooks
import { useState, useCallback } from "react";
import useEventListener from "../../hooks/useEventListener/index.js";
import templateStore from "../../client-store/template.store.js";
import getDocument from "../../common-utils/environment/getDocument.util.js";
export const useVisibility = () => {
    const [visibility, setVisibility] = useState(true);
    const payload = useCallback(() => {
        const isVisible = document.visibilityState === "visible";
        setVisibility(isVisible);
        templateStore.setVisible(isVisible);
    }, []);
    useEventListener({
        eventName: "visibilitychange",
        element: getDocument(),
        payload,
    });
    return visibility;
};
export default useVisibility;
